<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { getModuleIcon } from '@shared/ui/icons'
import ThemeToggle from '@shared/ui/ThemeToggle.vue'
import LanguageToggle from '@shared/ui/LanguageToggle.vue'
import { useAuth } from '@shared/composables/useAuth'
import { SIDEBAR_NAV_GROUPS, SIDEBAR_TOOL, isSidebarNavItemActive } from './sidebarNav'

const route = useRoute()
const router = useRouter()
const { currentUser } = useAuth()

function isActive(path: string) {
  return isSidebarNavItemActive(route.path, path)
}

function navigate(path: string) {
  router.push(path)
}
</script>

<template>
  <nav
    class="w-64 h-screen flex flex-col border-r p-md glass-surface"
  >
    <h2 class="text-lg font-bold text-text-primary mb-md">不系舟</h2>

    <div class="flex-1 overflow-y-auto space-y-md">
      <section
        v-for="group in SIDEBAR_NAV_GROUPS"
        :key="group.name"
        class="space-y-xs"
        :aria-label="group.name"
        data-nav-group
      >
        <h3 class="px-md text-xs font-medium text-text-secondary">{{ group.name }}</h3>
        <button
          v-for="item in group.items"
          :key="item.path"
          class="w-full flex items-center gap-sm px-md py-sm rounded-md text-left transition-colors"
          :class="isActive(item.path)
            ? 'bg-brand-primary/10 text-brand-primary font-bold'
            : 'text-text-secondary hover:bg-background-primary hover:text-text-primary'"
          :aria-current="isActive(item.path) ? 'page' : undefined"
          @click="navigate(item.path)"
        >
          <component
            v-if="getModuleIcon(item.module)"
            :is="getModuleIcon(item.module)"
            class="w-5 h-5"
          />
          <span class="text-sm">{{ item.name }}</span>
        </button>
      </section>

      <div class="pt-sm border-t border-border-subtle" data-nav-tool>
        <button
          class="w-full flex items-center gap-sm px-md py-sm rounded-md text-left transition-colors"
          :class="isActive(SIDEBAR_TOOL.path)
            ? 'bg-brand-primary/10 text-brand-primary font-bold'
            : 'text-text-secondary hover:bg-background-primary hover:text-text-primary'"
          :aria-current="isActive(SIDEBAR_TOOL.path) ? 'page' : undefined"
          @click="navigate(SIDEBAR_TOOL.path)"
        >
          <component
            v-if="getModuleIcon(SIDEBAR_TOOL.module)"
            :is="getModuleIcon(SIDEBAR_TOOL.module)"
            class="w-5 h-5"
          />
          <span class="text-sm">{{ SIDEBAR_TOOL.name }}</span>
        </button>
      </div>
    </div>

    <div class="pt-md border-t border-border-subtle space-y-sm">
      <button
        @click="router.push('/login')"
        class="w-full flex items-center gap-sm px-md py-sm rounded-md text-left transition-colors
               text-text-secondary hover:bg-background-primary hover:text-text-primary"
      >
        <span class="w-5 h-5 flex items-center justify-center rounded-full bg-brand-primary/20 text-brand-primary text-xs font-bold">
          {{ currentUser?.charAt(0) ?? '?' }}
        </span>
        <span class="text-sm">{{ currentUser ?? '未登录' }}</span>
        <span class="ml-auto text-xs text-text-secondary">切换</span>
      </button>
      <ThemeToggle />
      <LanguageToggle />
    </div>
  </nav>
</template>
